import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "text-right whitespace-nowrap"
};
const _hoisted_2 = {
  class: "flex-center ml-1"
};
import { ref } from "vue";
import { Player } from "@/modules/team/entity";
import Icon from "@/modules/vue/components/Icon.vue";
import { PositionEnum } from "@/modules/base/enums";
import PlayerContractNegotiationStarterComponent from "@/modules/team/components/PlayerContractNegotiationStarter.vue";
import PlayerList from "@/modules/team/components/PlayerList.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Contracts',
  async setup(__props) {
    let __temp, __restore;
    const players = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      players.value = collect(await Player.createQueryBuilder('player').leftJoin('player.team', 'team').innerJoinAndSelect('player.country', 'country').where('team.user = true').getMany()).sortBy(p => p.contractYears * 10 ** 6 + Object.values(PositionEnum).indexOf(p.position) * 1000 - p.skill);
    })), __temp = await __temp, __restore(), __temp);
    const router = useRouter();
    const starter = ref(null);
    const negotiate = async player => {
      await starter.value.negotiate(player);
    };
    const onStarted = negotiation => {
      router.push({
        name: 'negotiations.show',
        params: {
          id: negotiation.id
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(PlayerList, {
        players: players.value
      }, {
        action: _withCtx(({
          player
        }) => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, _toDisplayString(_ctx.$moneyPerMonth(player.wage)), 1), _createElementVNode("div", {
          class: _normalizeClass({
            'font-bold text-red-500': player.contractYears === 1
          })
        }, _toDisplayString(_ctx.$duration(player.contractYears, 'years').humanize()), 3)]), _createElementVNode("div", _hoisted_2, [player.endsCareer ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          icon: _ctx.IconEnum.FlagCheckered,
          class: "text-gray-500"
        }, null, 8, ["icon"])) : (_openBlock(), _createBlock(_component_NButton, {
          key: 1,
          secondary: "",
          size: "small",
          onClick: $event => negotiate(player)
        }, {
          default: _withCtx(() => [_createVNode(Icon, {
            icon: _ctx.IconEnum.Handshake20Regular
          }, null, 8, ["icon"])]),
          _: 2
        }, 1032, ["onClick"]))])]),
        _: 1
      }, 8, ["players"]), _createVNode(PlayerContractNegotiationStarterComponent, {
        ref_key: "starter",
        ref: starter,
        onStarted: onStarted
      }, null, 512)]);
    };
  }
});